<nrwl-cart-items-picker
  *ngIf="dataSource"
  [tableData]="dataSource"
  [singleSelection]="singleSelection"
  [persistenceID]="persistenceID"
  [cartView]="cartView"
  (closeModal)="closeModal($event)"
  [cartItems]="cartItems"
  [transformationString]="transformationString"
  [hidingData]="hidingDeviceData"
  [selectionLimit]="selectionLimit"
  [childRows]="havingChildRows"
  [pageConfigurations]="pageConfigurations"
></nrwl-cart-items-picker>
